import Axios from "axios";
import {
  SET_INVOICE_BILL_LIST,
  UNSET_INVOICE_BILL_LIST,
} from "@/store/mutation-types";

import { invoiceBillResource } from "@/store/api";

const state = {
  getInvoiceBillList: [],
};

const getters = {
  getInvoiceBillList(state) {
    return state.getInvoiceBillList;
  },
};

const mutations = {
  [SET_INVOICE_BILL_LIST](state, data) {
    state.getInvoiceBillList = data;
  },
  [UNSET_INVOICE_BILL_LIST](state) {
    state.getInvoiceBillList = [];
  },
};

const actions = {

    getInvoiceBillList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(invoiceBillResource, { params })
            .then((response) => {
            commit(SET_INVOICE_BILL_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_INVOICE_BILL_LIST);
            reject(error);
            });
        });
    },

    saveInvoiceBill({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(invoiceBillResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateInvoiceBill({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${invoiceBillResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getInvoiceBillById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${invoiceBillResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

